import styled from '@emotion/styled';
import rem from "../../utils/rem/rem";
import Link from "../../components/Link/Link";

export const EditFormHeader = styled.div`
    background-color: ${({ theme }) => theme.colors.gray200};
    padding: ${rem(16)} ${rem(32)};
`

export const Container = styled.div`
    display: flex;
    flex-flow: column nowrap;
`

export const Column = styled.div`
    display: flex;
    flex-flow: column nowrap;
`

export const TitleWithBreadcrumbContainer = styled(Container)`
    gap: ${rem(8)}
`

export const Breadcrumb = styled(Link)`
    width: max-content;
    color: ${({ theme }) => theme.colors.darkBlue};
`;

export const Title = styled.h1`
    font-family: 'Pizza Hut', serif;
    font-size: ${rem(28)};
`

export const EditForm = styled.form`
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-flow: row nowrap;
    overflow: auto;
    justify-content: space-between;
`

export const EditFormFields = styled(Column)`
    padding: ${rem(32)};
    gap: ${rem(16)};
`

export const FormFieldRow = styled.div`
    display: flex;
    flex-flow: row wrap;
    gap: ${rem(16)} ${rem(32)};
`;

export const FormRadioGroupContainer = styled.div`
    width: ${rem(170)};
`;

export const EditFormActions = styled(Column)`
    align-items: center;
    min-height: 100%;
    border-left: 1px solid ${({ theme }) => theme.colors.gray600};
    padding: ${rem(32)};
    flex-shrink: 0;

    button {
        min-width: ${rem(160)};
    }
`;
